import type { ReactElement } from "react";
import { useState } from "react";

import { IconButton, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import {
    StyledAddConditionContainer,
    StyledEmptyText,
} from "app/pages/sales-intelligence/common-components/filters-panel";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import type FindTechnologyFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/TechnologyFilter/TechnologyFilter";
import { TechnologyModal } from "app/pages/sales-intelligence/modules/technology/components/modals/TechnologyModal/TechnologyModal";
import type { TechnologiesFilterDto } from "app/pages/sales-intelligence/modules/technology/types/technologies";

export const TechnologyFilter = ({
    filter,
    value = [],
    onFilterUpdate,
}: IFilterViewBaseProps<FindTechnologyFilter>): ReactElement | null => {
    const { options } = filter;
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

    const handleOpenModal = () => {
        setIsOpenModal(true);
    };

    const renderAddButton = () => {
        const button = (
            <IconButton
                type="flat"
                iconName="add"
                onClick={handleOpenModal}
                dataAutomation="technologies-filter-button-add"
            >
                {translate(`si.lead_gen_filters.filters.technologies.button.add`)}
            </IconButton>
        );

        if (value && value?.length > 0) {
            return (
                <Tooltip content={translate(`si.lead_gen_filters.filters.technologies.button.add.tooltip`)}>
                    {button}
                </Tooltip>
            );
        }

        return button;
    };

    const handleClose = () => {
        setIsOpenModal(false);
    };

    const handleApply = (item: TechnologiesFilterDto) => {
        onFilterUpdate(value ? [...value, item] : [item]);
        setIsOpenModal(false);
    };

    return (
        <>
            <TechnologyModal
                isOpen={isOpenModal}
                selected={null}
                onClose={handleClose}
                onCancel={handleClose}
                onApply={handleApply}
                options={options}
                value={value}
                isExcludeAvailable={filter.isExcludeInclusionAvailable(value, null)}
            />

            <StyledEmptyText isHidden={!!(value && value?.length > 0)}>
                {translate(`si.lead_gen_filters.filters.technologies.empty_text`)}
            </StyledEmptyText>
            <StyledAddConditionContainer>{renderAddButton()}</StyledAddConditionContainer>
        </>
    );
};
